import { Link } from "react-router-dom";
const TrekCard = ({ trek }) => {
  return (
    <Link
      to={trek.path}
      className="group overflow-hidden rounded-2xl border border-amber-200 bg-white shadow-sm transition hover:-translate-y-1 hover:shadow-lg"
    >
      <img
        src={trek.image}
        alt={trek.name}
        className="h-28 w-full object-cover transition duration-500 group-hover:scale-105 sm:h-44"
      />
      <p className="p-3 text-sm font-semibold leading-5 text-stone-800 sm:p-4 sm:text-base">
        {trek.name}
      </p>
    </Link>
  );
};

export default TrekCard;
